import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../AdminPanel.css";
import Table from "react-bootstrap/Table";
import SuperAdminSidebar from "../SuperAdminSidebar";
import ManagerSidebar from "../ManagerSidebar";
import LeaderSidebar from "../LeaderSidebar";
import MemberSidebar from "../MemberSidebar";
import AdminNavbar from './AdminNavbar';

const ViewUser = () => {
    const navigate = useNavigate();
    const [userType, setUserType] = useState("");
    const [userFullName, setUserFullName] = useState("");
    const [users, setUsers] = useState([]);
    const [onlineUsers, setOnlineUsers] = useState([]);
    const [editUserId, setEditUserId] = useState(null);
    const [editData, setEditData] = useState({});
    const [loading, setLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);

    const IMAGE_BASE_URL = "https://skcapi.btcjapan.co/user-images/";

    // ===== TRACK USER ACTIVITY (Ping every 30 seconds) =====
    /*
    const trackActivity = () => {
        const currentUserId = localStorage.getItem("id") || localStorage.getItem("user_id") || localStorage.getItem("userId") || localStorage.getItem("userID");
        if (!currentUserId) return;

        fetch("https://skcapi.btcjapan.co/track_user_activity.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: currentUserId }),
        }).catch(err => console.error("Activity tracking error:", err));
    };
    */

    // ===== FETCH ONLINE USERS =====
    const fetchOnlineUsers = () => {
        fetch("https://skcapi.btcjapan.co/get_online_users.php")
        .then(response => response.json())
        .then(data => {
            if (data.Status === "200") {
            setOnlineUsers(data.Users);
            }
        })
        .catch(error => console.error("Error fetching online users:", error));
    };

    useEffect(() => {
        const storedUserType = localStorage.getItem("usertype");
        const storedFname = localStorage.getItem("fname");
        const storedLname = localStorage.getItem("lname");
        
        if (!storedUserType) {
        navigate("/login");
        } else {
        setUserType(storedUserType);
        setUserFullName(`${storedFname || ''} ${storedLname || ''}`.trim());
        }

        fetchUsers();
        fetchOnlineUsers();

        // ==========================================================
        // NEW: TRACK OWN ACTIVITY (Ping every 30 seconds) 
        // ==========================================================
        const currentUserId = localStorage.getItem("id") || localStorage.getItem("user_id") || localStorage.getItem("userId") || localStorage.getItem("userID");
        
        if (currentUserId) {
        trackUserActivity(currentUserId);
        const activityInterval = setInterval(() => trackUserActivity(currentUserId), 30000);
        
        const handleActivityVisibility = () => {
            if (!document.hidden) {
            trackUserActivity(currentUserId);
            }
        };
        
        document.addEventListener("visibilitychange", handleActivityVisibility);
        
        // Cleanup activity interval
        const cleanupActivity = () => {
            clearInterval(activityInterval);
            document.removeEventListener("visibilitychange", handleActivityVisibility);
        };
        
        // Combined cleanup for both intervals
        const onlineInterval = setInterval(fetchOnlineUsers, 15000);
        
        return () => {
            cleanupActivity();
            clearInterval(onlineInterval);
        };
        }
        
        // Fallback if no user ID
        const onlineInterval = setInterval(fetchOnlineUsers, 15000);
        return () => clearInterval(onlineInterval);
    }, [navigate]);

    const trackUserActivity = async (userId) => {
        try {
        const token = localStorage.getItem("token");
        await fetch("https://skcapi.btcjapan.co/track_user_activity.php", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            body: JSON.stringify({ user_id: userId }),
        });
        } catch (error) {
        console.error("Activity tracking error:", error);
        }
    };    

    const fetchUsers = () => {
        setLoading(true);
        fetch("https://skcapi.btcjapan.co/fetch_users.php")
            .then(response => response.json())
            .then(data => {
                if (data.Status === "200") {
                    setUsers(data.Users);
                } else {
                    console.error("Error fetching users:", data.Message);
                }
            })
            .catch(error => console.error("Error fetching users:", error))
            .finally(() => setLoading(false));
    };

    // ===== HELPER: Check if a user is online =====
    const isUserOnline = (userId) => {
        return onlineUsers.some(u => String(u.id) === String(userId));
    };

    // (Rest of your existing handleEdit, handleChange, handleSave, handleCancel, handleDelete functions remain unchanged)
    const handleEdit = (user) => {
        setEditUserId(user.id);
        setEditData({
            ...user,
            password: "",
            image: null
        });
    };

    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (name === "image") {
            if (files && files[0]) {
                setEditData({ ...editData, image: files[0] });
            }
        } else {
            setEditData({ ...editData, [name]: value });
        }
    };

    const handleSave = () => {
        const formData = new FormData();
        formData.append("id", editData.id);
        formData.append("fname", editData.fname);
        formData.append("lname", editData.lname);
        formData.append("email", editData.email);
        formData.append("usertype", editData.usertype);
        formData.append("status", editData.status);

        if (editData.password) {
            formData.append("password", editData.password);
        }

        if (editData.image && editData.image instanceof File) {
            formData.append("image", editData.image);
        }

        setLoading(true);
        fetch("https://skcapi.btcjapan.co/update_user.php", {
            method: "POST",
            body: formData,
        })
        .then(response => response.json())
        .then(data => {
            if (data.Status === "200") {
                setEditUserId(null);
                fetchUsers();
                alert("User updated successfully!");
            } else {
                console.error(data.Message);
                alert("Error: " + data.Message);
            }
        })
        .catch(error => {
            console.error(error);
            alert("Network error occurred");
        })
        .finally(() => setLoading(false));
    };

    const handleCancel = () => {
        setEditUserId(null);
        setEditData({});
    };

    const handleDelete = (id, imageName) => {
        if (window.confirm("Are you sure you want to delete this user? This action cannot be undone!")) {
            setDeleteLoading(true);
            fetch("https://skcapi.btcjapan.co/delete_user.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ 
                    id: id,
                    image: imageName
                }),
            })
            .then(response => response.json())
            .then(data => {
                if (data.Status === "200") {
                    alert("User deleted successfully!");
                    fetchUsers();
                } else {
                    alert("Error deleting user: " + data.Message);
                    console.error("Error deleting user:", data.Message);
                }
            })
            .catch(error => {
                console.error("Error deleting user:", error);
                alert("Network error occurred while deleting user");
            })
            .finally(() => setDeleteLoading(false));
        }
    };

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("userName");
        localStorage.removeItem("usertype");
        localStorage.removeItem("fname");
        localStorage.removeItem("lname");
        navigate("/login");
    };

    return (
        <div className="admin-container">
            <div className="sidebar-container">
              {userType === "administrator" && <SuperAdminSidebar />}
              {userType === "leader" && <LeaderSidebar />}
              {userType === "manager" && <ManagerSidebar />}
              {userType === "member" && <MemberSidebar />}
            </div>

            <div className="admin-content">
                <AdminNavbar/>

                <div className="main-content">

                    <div className="main-section">
                        <h3 className="section-title">
                            View All Users {"\u00a0"}{"\u00a0"}
                            (<span style={{ fontSize: "16px", color: "#666" }}>
                                {onlineUsers.length} Online
                            </span>)
                        </h3>
                        {loading && <p className="text-center">Loading...</p>}
                    </div>

                    <Table className="table table-striped align-middle">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Image</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Email</th>
                                <th>User Type</th>
                                <th>Status</th>
                                <th>Online Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.length > 0 ? (
                                users.map((user) => (
                                    <React.Fragment key={user.id}>
                                        <tr>
                                            <td>{user.id}</td>

                                            <td className="img-data">
                                                {user.image ? (
                                                    <img
                                                        src={`${IMAGE_BASE_URL}${user.image}`}
                                                        alt={`${user.fname} ${user.lname}`}
                                                        style={{
                                                            width: "40px",
                                                            height: "40px",
                                                            objectFit: "cover",
                                                            borderRadius: "50%",
                                                            border: "1px solid #ddd"
                                                        }}
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = "https://via.placeholder.com/50?text=No+Img";
                                                        }}
                                                    />
                                                ) : (
                                                    <div
                                                        style={{
                                                            width: "40px",
                                                            height: "40px",
                                                            borderRadius: "50%",
                                                            backgroundColor: "#e9ecef",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            fontSize: "12px",
                                                            color: "#6c757d"
                                                        }}
                                                    >
                                                        No Img
                                                    </div>
                                                )}
                                                <div className="badge-cover">
                                                    {isUserOnline(user.id) ? (
                                                    <span className="img-badge ">🟢</span>
                                                ) : (
                                                    <span className="img-badge ">⚪</span>
                                                )}
                                                </div>                                            
                                            </td>

                                            <td>{user.fname}</td>
                                            <td>{user.lname}</td>
                                            <td>{user.email}</td>
                                            <td>{user.usertype}</td>
                                            <td>
                                                <span className={`badge bg-${user.status === 'Active' ? 'success' : 'warning'}`}>
                                                    {user.status}
                                                </span>
                                            </td>

                                            {/* NEW: Online Status */}
                                            <td>
                                                {isUserOnline(user.id) ? (
                                                    <span className="badge bg-success">🟢 Online</span>
                                                ) : (
                                                    <span className="badge bg-secondary">⚪ Offline</span>
                                                )}
                                            </td>

                                            <td>
                                                <button
                                                    className="btn btn-warning btn-sm me-1"
                                                    onClick={() => handleEdit(user)}
                                                    disabled={loading}
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => handleDelete(user.id, user.image)}
                                                    disabled={deleteLoading}
                                                >
                                                    {deleteLoading ? 'Deleting...' : 'Delete'}
                                                </button>
                                            </td>
                                        </tr>

                                        {/* Edit row (unchanged) */}
                                        {editUserId === user.id && (
                                            <tr>
                                                <td colSpan="9">
                                                    <div className="row mb-2">
                                                        <div className="col-lg-4">
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                name="fname"
                                                                value={editData.fname || ""}
                                                                onChange={handleChange}
                                                                placeholder="First Name"
                                                            />
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                name="lname"
                                                                value={editData.lname || ""}
                                                                onChange={handleChange}
                                                                placeholder="Last Name"
                                                            />
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <input
                                                                className="form-control"
                                                                type="email"
                                                                name="email"
                                                                value={editData.email || ""}
                                                                onChange={handleChange}
                                                                placeholder="Email"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <div className="col-lg-3">
                                                            <select
                                                                className="form-control"
                                                                name="usertype"
                                                                value={editData.usertype || ""}
                                                                onChange={handleChange}
                                                            >
                                                                <option value="administrator">Administrator</option>
                                                                <option value="leader">Leader</option>
                                                                <option value="manager">Manager</option>
                                                                <option value="member">Member</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <select
                                                                className="form-control"
                                                                name="status"
                                                                value={editData.status || ""}
                                                                onChange={handleChange}
                                                            >
                                                                <option value="Active">Active</option>
                                                                <option value="Pending">Pending</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <input
                                                                className="form-control"
                                                                type="password"
                                                                name="password"
                                                                placeholder="Enter new password (optional)"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <input
                                                                type="file"
                                                                name="image"
                                                                className="form-control"
                                                                accept="image/*"
                                                                onChange={handleChange}
                                                            />
                                                        </div>                                                    
                                                    </div>

                                                    <button
                                                        className="btn btn-primary btn-sm mb-2"
                                                        onClick={handleSave}
                                                        disabled={loading}
                                                    >
                                                        {loading ? 'Saving...' : 'Save'}
                                                    </button>
                                                    <button
                                                        className="btn btn-secondary btn-sm mb-2"
                                                        style={{ marginLeft: "10px" }}
                                                        onClick={handleCancel}
                                                    >
                                                        Cancel
                                                    </button>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" className="text-center">
                                        {loading ? 'Loading users...' : 'No users found'}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    );
};

export default ViewUser;